<template>
  <div class="edit-cash-boxes-opening-balance">

    <div class="edit-cash-boxes-opening-balance-box">

      <vs-row class="my-2">
        <vs-col class="w-full">
          <custom-price-input :label="`${$t('treasury.cashBoxes.openingBalance.labels.price')}`"
                              :is-empty="true"
                              :autocomplete="false"
                              :name="Math.random()"
                              :classes="{'w-full': true}"
                              v-model="updatedCashBox.price"
                              @pressEnter="sendData"/>
        </vs-col>
      </vs-row>
    </div>

    <custom-dialog ref="deleteOpeningBalanceConfirmation"
                   :title="`${$t('treasury.cashBoxes.openingBalance.confirmations.delete.title')}`"
                   :body="`${$t('treasury.cashBoxes.openingBalance.confirmations.delete.body')}`"
                   @accept="handleDeleteCashBoxOpeningBalance"/>

    <button v-show="false" id="saveBTN" @click="sendData"/>
  </div>
</template>

<script>
import axios from 'axios'
import CustomIcon from '../../../../../components/customIcon/customIcon'
import {
  deleteCashBoxesOpeningInventories,
  setCashBoxesOpeningInventories
} from '../../../../../http/requests/openingInventories'
import CustomDialog from '../../../../../components/customDialog/customDialog'
import CustomPriceInput from "../../../../../components/customInput/customPriceInput.vue";

export default {
  name: 'editCashBoxesOpeningBalance',
  components: {CustomPriceInput, CustomDialog, CustomIcon},
  props: {
    cashBox: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      updatedCashBox: {
        price: {value: ''}
      }
    }
  },
  created () {
    this.updatedCashBox = JSON.parse(JSON.stringify(this.cashBox))
    this.updatedCashBox.price = {
      value: this.cashBox.price,
      isValid: true
    }
  },
  methods: {
    sendData () {
      if ((this.updatedCashBox.price.value || '0') === '0') {
        this.handleDeleteCashBoxOpeningBalance()
        return false
      }

      const cashBox = {
        id: this.updatedCashBox.id,
        price: this.$u.parseFloat(this.updatedCashBox.price.value.toString().replaceAll(',', ''))
      }
      setCashBoxesOpeningInventories([cashBox]).then(() => {
        this.$vs.notify({
          title: this.$t('alert.message.title'),
          text: this.$t('treasury.cashBoxes.openingBalance.notifications.edit.success'),
          color: 'success',
          time: 2400,
          icon: 'icon-check',
          iconPack: 'feather'
        })

        this.$store.dispatch('helper/changeOpeningBalance')
      }).catch((error) => {
        if (axios.isCancel(error)) {
          this.$vs.notify({
            title: this.$t('alert.duplicateRequest.title'),
            text: this.$t('alert.duplicateRequest.message'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: 2400,
            color: 'warning'
          })
        } else {
          switch (error.response.status) {
            case 406:
              this.$vs.notify({
                title: this.$t('alert.error.title'),
                text: this.$t('treasury.cashBoxes.openingBalance.notifications.negativeBalance'),
                color: 'danger',
                time: 2400,
                icon: 'icon-alert-circle',
                iconPack: 'feather'
              })
              break

            default:
              this.$vs.notify({
                title: this.$t('alert.error.title'),
                text: this.$t('treasury.cashBoxes.openingBalance.notifications.edit.error'),
                color: 'danger',
                time: 2400,
                icon: 'icon-alert-circle',
                iconPack: 'feather'
              })
              break
          }
        }
      })
    },
    handleDeleteCashBoxOpeningBalance () {
      if (this.cashBox && this.cashBox.id) {
        deleteCashBoxesOpeningInventories(this.cashBox.id).then(() => {
          this.$vs.notify({
            title: this.$t('alert.message.title'),
            text: this.$t('treasury.cashBoxes.openingBalance.notifications.delete.success'),
            color: 'success',
            time: 2400,
            icon: 'icon-check',
            iconPack: 'feather'
          })

          this.$store.dispatch('helper/deleteOpeningBalance')
        }).catch((error) => {
          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          } else {
            this.$vs.notify({
              title: this.$t('alert.error.title'),
              text: this.$t('treasury.cashBoxes.openingBalance.notifications.delete.error'),
              color: 'danger',
              time: 2400,
              icon: 'icon-alert-circle',
              iconPack: 'feather'
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.select-file-input {
  width: 100%;
  background: #28c76f;
  display: block;
  padding: 10px;
  border-radius: .5rem;

  span {
    color: white !important;

    div.icon {
      background-color: white !important;
    }
  }

  input {
    display: none;
  }
}
</style>
